import { useQuery } from "@tanstack/react-query";
import { RestEndpoints } from "../../../api/endpoints";
import { ReactQueryConfig } from "../../../config/react-query-config";
import getInstance from "../../../utils/rest";
import { GroupTypeFilterValues } from "../../../components/group/group-filter/group-type-filter.component";
import { PaginationMetaConverter } from "../../../domain/converter/pagination-meta.converter";
import { UserConverter } from "../../../domain/converter/user.converter";
import { IPaginationMeta } from "../../../domain/pagination/pagination-meta";
import { IUserResult } from "../../../domain/user/user";
import { IUserListModel } from "../../../models/user/user.model";
import { SharedQueryKeys } from "../query-keys";

export interface IUsersFilter {
  active?: boolean;
  emailQuery?: string;
  lastNameQuery?: string;
  groupTypes?: GroupTypeFilterValues[];
}

const getUsersWithFilters = async (filter: IUsersFilter, pagination: { page: number; pageSize: number }): Promise<IUserResult> => {
  const { active, groupTypes, emailQuery, lastNameQuery } = filter;
  const { page, pageSize } = pagination;
  const { data } = await getInstance().get<IUserListModel>(RestEndpoints.AllUsers, {
    params: { active, groupTypes, emailQuery, lastNameQuery, page, pageSize },
  });
  return {
    users: data.users.map(UserConverter.toDomain),
    meta: data.meta ? PaginationMetaConverter.toDomain(data.meta) : undefined,
  };
};

export const useGetUsersWithFiltersQuery = (
  filter: IUsersFilter,
  enabled: boolean = true,
  pagination: IPaginationMeta,
) => {
  const { page, pageSize } = pagination;
  return useQuery({
    queryKey: [SharedQueryKeys.GetUsersWithFilter, { page, pageSize }, filter],
    queryFn: () => getUsersWithFilters(filter, { page, pageSize }),
    staleTime: ReactQueryConfig.staleTime,
    enabled,
  });
};
